import Frbypasslinks from 'fr-bypasslinks'

const bypassLinks = Frbypasslinks({
  selector: '.js-fr-bypasslinks'
})

export default { bypassLinks, Frbypasslinks }



// WEBPACK FOOTER //
// ./ita-web-toolkit/src/components/skiplinks/index.js